module.exports = __webpack_public_path__ + "img/08.ba3130c8.svg";